import { MODALS } from 'MODULES/MODALS';
import { showModal } from 'ACTIONS/ui/showModal';
import { SET_CONFIRMATION_DATA } from 'ACTIONS';

export const showModalWithData = (data, modalToToggle = MODALS.confirmation, method = true) => (dispatch) => {
    dispatch(showModal(modalToToggle, method));
    dispatch({ type: SET_CONFIRMATION_DATA, payload: data });
};
